





import {SvgSymbolData} from '@/icons/index';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class SvgIcon extends Vue {
    @Prop({type: Object, required: true})
    public readonly symbolData: SvgSymbolData;
}
